import React from 'react';

import TabsHeader from '@shared/components/TabsHeader';
import { Payments } from './Payments';

export default () => {
  return (
    <>
      <TabsHeader site={3} />
      <Payments />
    </>
  );
};
